import type { LetterPreviewCheck } from "../../../../../../../../../api/kehrblatt/letters"
import type { LetterDraft } from "../_shared/_logic/letter-types"
export const variantLabels = {
  announcement: "Ankündigung",
  reschedule: "Verschiebung",
  aushang: "Aushang",
} as const
export const overflowMessage = (checks: LetterPreviewCheck[]): string | null => {
  const overflowing = checks.filter((check) => check.page_count > 1)

  if (!overflowing.length) return null

  return (
    "Bitte kürzen Sie die Vorlage. Mehrseitige Musterbriefe: " +
    overflowing
      .map(
        (check) =>
          `${variantLabels[check.variant]} (${check.variant === "aushang" ? "" : check.recipient_mode === "personal" ? "mit Name, " : "ohne Name, "}${check.page_count} Seiten)`,
      )
      .join("; ")
  )
}
export const validateDraft = (draft: LetterDraft): string | null => {
  if (
    Object.values(draft.letter_address_window).some(
      (value) => !Number.isFinite(Number(value)) || Number(value) <= 0,
    )
  ) {
    return "Bitte geben Sie für alle Fensterbriefmaße positive Zahlen ein."
  }

  const portal = draft.portal
  for (const step of [
    portal.open_portal,
    portal.confirm_appointment,
    portal.choose_alternative,
    portal.complete,
  ]) {
    if (
      (step.enabled && (!step.title.trim() || !step.body.trim())) ||
      step.title.length > 120 ||
      step.body.length > 500
    )
      return "Bitte prüfen Sie die Überschriften und Texte der vier Schritte."
  }

  if (
    !portal.response_hint.trim() ||
    portal.response_hint.length > 300 ||
    portal.support_heading.length > 120 ||
    portal.support_body.length > 1000
  )
    return "Bitte prüfen Sie Rückmeldehinweis und Kontaktbox."

  return null
}
